<div *ngIf="appt" class="inner-content">
  <p class="SCWEB-header-text">Your receipt</p>
  <div id="receipt-wrapper">
    <receipt [appt]="appt">
    </receipt>
  </div>
</div>